import React, { PropsWithChildren, useState } from "react";
import { Drawer, Layout, theme } from "antd";

import { ReactComponent as Harmbugger } from "../../svgs/hambugger.svg";
import styles from "./main.module.css";
import SideBar from "./sidebar";
import { Outlet } from "react-router-dom";
import { handleLogOut, logoutIfTokenExpired } from "../helpers";
import { useAtom } from "jotai";
import { userAtom } from "../../utils/store";

interface ComponentProp extends PropsWithChildren {}

const { Content } = Layout;

const CLayout: React.FC<ComponentProp> = ({ children }) => {
  const [open, setOpen] = useState([false, false]);
  const [user] = useAtom(userAtom)

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const toggleDrawer = (idx: number, target: boolean) => {
    setOpen((p) => {
      p[idx] = target;
      return [...p];
    });
  };

  if(logoutIfTokenExpired(user?.expiryDate)){
    handleLogOut();
  }

  return (
    <main className={styles.main}>
      <Drawer
        placement="left"
        onClose={() => toggleDrawer(0, false)}
        open={open[0]}
        className={styles.drawer}
        width={"300px"}
        styles={{
          body: { padding: "0px" },
          header: { backgroundColor: "#335642" },
        }}
      >
        <SideBar className={styles.drawSideBar} />
      </Drawer>

      <SideBar className={styles.sideBar} />

      <div className={styles.superHeader}>
        <Content
          className={styles.content}
          style={{
            paddingBlock: 24,
            margin: 0,
            maxHeight: "100vh",
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <div>
            <Harmbugger
              onClick={() => toggleDrawer(0, true)}
              className={styles.harmbugger}
            />
          </div>

          {children}
          {/* <Outlet /> */}
        </Content>
      </div>
    </main>
  );
};

export default CLayout;
